import { PermissionAccessLevel, Permission } from '@services/auth/authorization';
import { Directive, Input, ElementRef, Renderer2, OnInit } from '@angular/core';
import { PermissionsService } from '@services/auth/permissions.service';

@Directive({
  selector: '[appHideIfUnauthorized]'
})
export class HideIfUnauthorizedDirective implements OnInit {
  @Input() section: Permission;
  @Input() allowedActions: PermissionAccessLevel[];

  constructor(private el: ElementRef, private renderer: Renderer2, private permissions: PermissionsService) {}

  ngOnInit() {
    if (!this.allowedActions.includes(this.permissions.getPermission(this.section))) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    }
  }
}
